<template>
  <ResourceDialog
    @cancel="$emit('cancel', $event)"
    @save="$emit('confirm', $event)"
    ref="dialog"
    :cancel-button-text="cancelButtonText"
    :max-width="600"
    :save-button-text="confirmButtonText"
    :title="title"
    close-on-save
    scrim
  >
    <template #form="{ localValue: addressFormData }">
      <v-row v-if="addressFormData?.value">
        <v-col
          cols="12"
          md="6"
        >
          <v-card
            class="mb-4"
            border
          >
            <v-card-title>
              <h3 class="fs-20">
                {{ $bct('You entered') }}
              </h3>
            </v-card-title>
            <v-card-text data-testid="current-address">
              <p>
                {{ addressFormData.value[addressKey] }}
                <br />
                {{
                  `${addressFormData.value[cityKey]}, ${addressFormData.value[stateKey]} ${addressFormData.value[zipKey]}`
                }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <v-card
            class="mb-4"
            border
          >
            <v-card-title>
              <h3 class="fs-20">
                {{ $bct('Recommended') }}
              </h3>
            </v-card-title>
            <v-card-text data-testid="recommended-address">
              <p>
                {{ addressFormData.standardizedAddress.firstAddressLine }}
                <br />
                {{ addressFormData.standardizedAddress.city }},
                {{ addressFormData.standardizedAddress.state }}
                {{ addressFormData.standardizedAddress.zipCode }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </ResourceDialog>
</template>

<script setup>
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';

const $bct = inject('translator');

const props = defineProps({
  addressKey: {
    default: 'home_address',
    type: String,
  },
  cancelButtonText: {
    default: 'Back',
    type: String,
  },
  cityKey: {
    default: 'home_city',
    type: String,
  },
  confirmButtonText: {
    default: 'Use recommended',
    type: String,
  },
  stateKey: {
    default: 'home_state',
    type: String,
  },
  title: {
    default: 'Verify address',
    type: String,
  },
  value: {
    default: null,
    type: Object,
  },
  zipKey: {
    default: 'home_zip',
    type: String,
  },
});

defineEmits(['cancel', 'confirm']);

const dialog = ref(null);

onMounted(() => {
  if (props.value) open(props.value);
});

function open(newValue) {
  dialog.value.open(newValue);
}

defineExpose({ open });
</script>
